module.exports = "/_next/static/images/HCGO_Mini_Web-Banner-a74b75060dc02ee30a6356d71d29170a.jpg";